import { Link } from "@inertiajs/react"

/**
 * Sits immediately after Recently Sold Firearms, where the visitor has just been
 * looking at what guns actually sold for.
 */
export const NeedCashBanner = () => (
    <Link
        href="/sell-my-gun"
        className="seller-lift block w-full bg-[#202020] px-[22px] py-[26px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-white md:p-10"
    >
        <span className="mx-auto flex max-w-[1120px] flex-col md:flex-row md:items-center md:gap-10">
            <span className="md:flex-1">
                <h2 className="text-[24px] font-bold leading-[1.18] text-white md:text-[30px]">
                    Need cash for your next buy?
                </h2>
                <p className="mt-2.5 text-[16.5px] leading-[1.55] text-dark-body md:mt-0">
                    Sell us the guns you don't shoot anymore. Cash offer, often
                    within a few hours, free shipping, and you never have to
                    leave home.
                </p>
            </span>

            <span className="relative mt-5 block overflow-hidden rounded-full bg-[#800020] p-[15px] text-center text-[15px] font-bold uppercase tracking-[.06em] text-white md:mt-0 md:w-[280px] md:flex-none">
                <span
                    aria-hidden="true"
                    className="pointer-events-none absolute inset-y-0 left-0 w-1/3 animate-cta-sheen bg-gradient-to-r from-transparent via-white/20 to-transparent motion-reduce:hidden"
                />
                <span className="relative z-10">Get a cash offer</span>
            </span>
        </span>
    </Link>
)
